import { apiTypes } from 'ui/api'

export const providersWithDatePicker: apiTypes.ApiProviderName[] = ['UPS']
